import { Button } from "devextreme-react";
import React, { useState } from "react";
import CustomTextBox from "../../../components/customTextBox/CustomTextBox";
import "./ConfigurationTab.scss";
import { ToastDisplayer } from "../../../components/toastDisplay/ToastDisplayer";
import { LoadPanel } from "devextreme-react/data-grid";
import { validateEmail } from "../../../components/login-form/LoginForm";
import { assignEmailApi } from "../../../api/settingsApi";
import { useAuth } from "../../../contexts/auth";
import { useEffect } from "react";

export default function ConfigurationTab({ getEmails }) {
  const [isEmailOtpVerifyOpen, setIsEmailOtpVerifyOpen] = useState(false);
  // const [isAssignEmailOpen, setIsAssignEmailOpen] = useState(false);
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [assignEmails, setAssignEmails] = useState({ email1: "", email2: "" });

  const handleEmailOtpVerifyDrop = () => {
    return setIsEmailOtpVerifyOpen(!isEmailOtpVerifyOpen);
  };

  // const handleAssignEmailDrop = () => {
  //   return setIsAssignEmailOpen(!isAssignEmailOpen);
  // };

  const yesnoDataSource = [
    {
      value: 1,
      text: "Yes",
    },
    {
      value: 2,
      text: "No",
    },
  ];

  const handleInputChange = (name) => (e) => {
    const value = e.value;
    setAssignEmails((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSaveSettingsDetail = async () => {
    try {
      setLoading(true);

      if (assignEmails.email1 || assignEmails.email2) {
        const trimmedEmail1 = assignEmails.email1?.trim() || "";
        const trimmedEmail2 = assignEmails.email2?.trim() || "";
        if (
          (trimmedEmail1 && !validateEmail(trimmedEmail1)) ||
          (trimmedEmail2 && !validateEmail(trimmedEmail2))
        ) {
          ToastDisplayer("error", "One or more email addresses are invalid!");
          return;
        }

        const mydata = {
          company_transid: user?.companytransid,
          primary_email: trimmedEmail1 || getEmails.email1, // Use trimmed email1 or fallback
          alt_email: trimmedEmail2 || getEmails.email2, // Use trimmed email2 or fallback
        };

        const result = await assignEmailApi(mydata);

        if (result.status === 200) {
          ToastDisplayer("success", result.data?.message);
        }
      }
      // else {
      //   ToastDisplayer("error", "Configuration emails are empty!");
      // }
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          error.response?.statusText,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setAssignEmails({
      email1: getEmails.email1 || "",
      email2: getEmails.email2 || "",
    });
  }, [getEmails]);

  return (
    <>
      <div className="innerTab">
        <div className="role-user-detail-header-container">
          <div className="add-user-detail">
            <div className="popup-header-text">
              Assign Email for Ticket Updates
            </div>
            <div className="add-user-arrow">
              {/* <Button
                className="add-user-arrow-button"
                onClick={handleAssignEmailDrop}
              >
                <i
                  class={`ri-arrow-${isAssignEmailOpen ? "up" : "down"}-s-line`}
                ></i>
              </Button> */}
            </div>
          </div>
        </div>
        <div className="confDropdownMain">
          <CustomTextBox
            label="Primary Email Address"
            value={assignEmails.email1}
            placeholder={"Type email address"}
            //value={assignEmails.email1}
            onChange={handleInputChange("email1")}
            type="email"
            noRequired={"no"}
          />
          <CustomTextBox
            label="Secondary Email Address"
            value={assignEmails.email2}
            placeholder={"Type email address"}
            //value={assignEmails.email2}
            onChange={handleInputChange("email2")}
            type="email"
            noRequired={"no"}
          />
        </div>
        <div className="modifyBtnContainer">
          <Button
            text="SAVE"
            className="filterBtn"
            onClick={handleSaveSettingsDetail}
            stylingMode="outlined"
          />
        </div>

        {/* removed this 2 div from condition confDropdownMain and  modifyBtnContainer */}
        {/* {isAssignEmailOpen ? (
          <>
          
          </>
        ) : (
          ""
        )}
  */}
      </div>
    </>
  );
}
